import {
    EuiPage,
    EuiPageBody,
    EuiPageHeader,
    EuiPageSection,
} from "@elastic/eui";
import React from "react";
import {AudienceSearcher} from "../../components/audience/AudienceSearcher";

export const AudiencesPage: React.FC = () => {

    return (
        <EuiPage>
            <EuiPageBody>
                <EuiPageSection>
                    <EuiPageHeader pageTitle={"Audiences"}/>
                </EuiPageSection>
                <EuiPageSection>
                    <AudienceSearcher/>
                </EuiPageSection>
            </EuiPageBody>
        </EuiPage>
    )
}